import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const summerPromo2026: boolean = getFeature('summer-promo-2026');

export const summerPromo2026Anonym: boolean = getFeature('summer-promo-2026-anonym');

export const summerPromo2026AnalyticsName = 'mnz_summer_promo_2026';

export const summerSale2026SidebarButton = isFeature('summer-sale-2026-sidebar-button');

export const summerSale2026SidebarBanner = isFeature('summer-sale-2026-sidebar-banner');

export const summerPromo2026ExpirationMs = getFeature('summer-promo-2026-expiration-ms') || 24 * 60 * 60 * 1000; // 1 день
export const summerPromo2026ShowInterval = getFeature('summer-promo-2026-show-interval') || 2 * 24 * 60 * 60 * 1000; // 2 дня
